import React, { FC } from 'react';
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';

interface IProps {
    onClick: () => void;
    color?: string;
    width?: number;
    height?: number;
}

const SortIcon: FC<IProps> = ({ color = 'rgba(0, 0, 0, 0.25)', width = 8, height = 12, onClick }) => {
    return (
        <div className="flex flex-col items-center -space-y-1" onClick={onClick}>
            <CaretUpFilled style={{ color, width: `${width}px`, height: `${height}px` }} />
            <CaretDownFilled style={{ color, width: `${width}px`, height: `${height}px` }} />
        </div>
    );
};

export default SortIcon;
